import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  authUser: null,
  credentials: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    },
    setAuthUser(state, action) {
      state.authUser = action.payload;
    },
    clearUser(state) {
      state.user = null;
      state.authUser = null;
      state.credentials = null;
    },
    setCredentials(state, action) {
      state.credentials = action.payload;
    },
    markProfileCompleted(state) {
      if (!state.user?.data?.user) return;

      state.user.data.user.isProfileCompleted = true;

      state.user.data.user.currentStep = null;
    },
    updateCurrentStep(state, action) {
      if (!state.user?.data?.user) return;
      state.user.data.user.currentStep = action.payload;
    },
  },
});

export const {
  setUser,
  setAuthUser,
  clearUser,
  markProfileCompleted,
  updateCurrentStep,
  setCredentials,
} = userSlice.actions;

export default userSlice.reducer;
